import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import * as SessionHelper from '../helpers/sessionHelper';
import { SessionInfo } from '../models/sessionInfo';

const localStorageSession = SessionHelper.loadSession();
const initialState: SessionInfo = {
  refreshToken: localStorageSession.refreshToken,
  sessionToken: localStorageSession.sessionToken,
  user: localStorageSession.user ? localStorageSession.user.id : undefined,
};

export function sessionReducer(state: SessionInfo = initialState, action: AllActions): SessionInfo {
  switch (action.type) {
    case InternalActionTypes.LoginSuccessful:
      return action.result.entities.sessions.undefined;
    case InternalActionTypes.Logout:
      SessionHelper.clearSession();

      return {
        refreshToken: undefined,
        sessionToken: undefined,
        user: undefined,
      };
    default:
      return state;
  }
}
